import { Stack } from 'components';
import { useState } from 'react';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';
import { useAppSelector } from 'store/hooks';

import style from './noteHistory.module.scss';
import NoteHistoryItem from './NoteHistoryItem';

type Props = {
  note: ClientProfileContentItem;
};

const NoteHistory = ({ note }: Props) => {
  const [showHistory, setShowHistory] = useState(false);
  const sitesEnabled = useAppSelector((state) => state.clients.client.data?.enableProgramSites);
  const noteHistory = note.noteHistory;

  if (!noteHistory || noteHistory.length === 0) {
    return null;
  }

  return (
    <Stack className={style.historyContainer} boxSizing="border-box">
      <Stack
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        boxSizing="border-box"
        mb="16px"
      >
        <button
          type="button"
          className={style.viewHistoryButton}
          onClick={() => setShowHistory(!showHistory)}
        >
          <span className="material-icons" data-icon data-expanded={showHistory}>
            expand_more
          </span>
          <span>Previous Final Versions</span>
        </button>
      </Stack>
      {showHistory && (
        <Stack display="flex" flexDirection="column" gap="16px">
          {noteHistory.map((historyItem, index) => (
            <NoteHistoryItem
              key={historyItem.id || index}
              historyItem={historyItem}
              sitesEnabled={sitesEnabled}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default NoteHistory;
